__turbopack_context__.v({
  "backfaces": "PrintView-module__xCGlfq__backfaces",
  "flip": "PrintView-module__xCGlfq__flip",
});
